import type { TagTone } from '@peles/shared';

/*
 * Written out whole, never built from the tone's name: Tailwind keeps only the
 * classes it finds spelled in the source. Each is a themed scale, so a badge
 * is a pale wash with dark ink in light mode and the reverse in dark.
 */
const TONE_CLASSES: Record<TagTone, string> = {
  blue: 'bg-blue-50 text-blue-700 ring-blue-200',
  green: 'bg-green-50 text-green-700 ring-green-200',
  amber: 'bg-amber-50 text-amber-800 ring-amber-200',
  red: 'bg-red-50 text-red-700 ring-red-200',
  purple: 'bg-purple-50 text-purple-700 ring-purple-200',
  teal: 'bg-teal-50 text-teal-700 ring-teal-200',
  orange: 'bg-orange-50 text-orange-700 ring-orange-200',
  pink: 'bg-pink-50 text-pink-700 ring-pink-200',
  indigo: 'bg-indigo-50 text-indigo-700 ring-indigo-200',
  cyan: 'bg-cyan-50 text-cyan-800 ring-cyan-200',
  gray: 'bg-gray-100 text-gray-700 ring-gray-200',
};

interface TagBadgeProps {
  label: string;
  tone: TagTone;
  className?: string;
}

/** A small coloured label — a file's document type, and anything sorted like one. */
export function TagBadge({ label, tone, className = '' }: TagBadgeProps) {
  return (
    <span
      className={`inline-flex items-center max-w-full truncate rounded-full px-1.5 py-0.5 text-[10px] font-medium ring-1 ring-inset ${TONE_CLASSES[tone]} ${className}`}
      data-tone={tone}
    >
      {label}
    </span>
  );
}
